module.exports = __webpack_public_path__ + "static/media/play-music.36f34dee.mp3";